import type { TemplateVariable } from '../../types'

type VariablesInput = TemplateVariable[] | Record<string, unknown> | undefined

function getRawVariable(variables: VariablesInput, title: string): unknown {
  if (!variables) return undefined
  if (Array.isArray(variables)) {
    return variables.find((variable) => variable.title === title)?.value
  }
  return variables[title]
}

export function getTextVariable(
  variables: VariablesInput,
  title: string,
  fallback = ''
): string {
  const value = getRawVariable(variables, title)
  return typeof value === 'string' ? value : fallback
}

export function getArrayVariable<T = unknown>(
  variables: VariablesInput,
  title: string,
  fallback: T[] = []
): T[] {
  const value = getRawVariable(variables, title)
  return Array.isArray(value) ? (value as T[]) : fallback
}

export function getVariable<T = unknown>(
  variables: VariablesInput,
  title: string
): T | undefined {
  return getRawVariable(variables, title) as T | undefined
}
